(() => {
  'use strict';

  const page = document.getElementById('apple-home-page');
  if (!page || page.dataset.navigationReady === 'true') return;
  page.dataset.navigationReady = 'true';

  // Scene copy and products mirror the Japanese v40 reference.
  const scenes = {
    "titles": [
      "家の今を、ひと目で。",
      "指先で、機器を操作。",
      "帰宅を、ひとつのシーンに。"
    ],
    "bodies": [
      "Apple Home で、対応機器の状態を確認。",
      "タップで、お部屋の温度を調整。",
      "対応機器で、Arrive Home シーンを設定。"
    ],
    "quotes": [
      "“Hey Siri, is the front door locked?”",
      "",
      "“Hey Siri, activate Arrive Home.”"
    ],
    "products": [
      "温湿度計Pro · ロック Ultra · カーテン3（U型）",
      "",
      "カーテン3（U型） · Nanoleaf Shapes"
    ],
    "thumbs": [
      [
        "aplh-jp-meter-v30.jpg",
        "apple-home-017-b560b67a9f.jpg",
        "aplh-jp-curtain-u-v30.jpg"
      ],
      [],
      [
        "aplh-jp-curtain-u-v30.jpg",
        "apple-home-035-d315447454.png"
      ]
    ],
    "productNames": [
      [
        "温湿度計Pro",
        "ロック Ultra",
        "カーテン3（U型）"
      ],
      [
        "Nanoleaf Shapes"
      ],
      [
        "カーテン3（U型）",
        "Nanoleaf Shapes"
      ]
    ],
    "productLinks": [
      [
        "/products/switchbot-meter-pro",
        "/products/switchbot-lock-ultra",
        "/products/switchbot-curtain3?variant=42699920769199"
      ],
      [
        "https://nanoleaf.me/en-jp/products/nanoleaf-shapes"
      ],
      [
        "/products/switchbot-curtain3?variant=42699920769199",
        "https://nanoleaf.me/en-jp/products/nanoleaf-shapes"
      ]
    ],
    "sceneProducts": [
      [
        [
          "温湿度計Pro",
          "aplh-jp-meter-v30.jpg",
          "/products/switchbot-meter-pro"
        ],
        [
          "ロック Ultra",
          "apple-home-017-b560b67a9f.jpg",
          "/products/switchbot-lock-ultra"
        ],
        [
          "カーテン3（U型）",
          "aplh-jp-curtain-u-v30.jpg",
          "/products/switchbot-curtain3?variant=42699920769199"
        ]
      ],
      [
        [
          "ハブ3",
          "aplh-jp-hub3-v30.jpg",
          "/products/switchbot-hub3"
        ]
      ],
      [
        [
          "ロック Ultra",
          "apple-home-017-b560b67a9f.jpg",
          "/products/switchbot-lock-ultra"
        ],
        [
          "Nanoleaf Shapes",
          "apple-home-035-d315447454.png",
          "https://nanoleaf.me/en-jp/products/nanoleaf-shapes"
        ]
      ]
    ],
    "sceneProductLabels": [
      "対応製品",
      "Matter 接続の入口",
      "帰宅シーンに組み合わせる機器"
    ]
  };

  const experience = page.querySelector('#ah-homeview-experience');
  if (experience) {
    const tabs = Array.from(experience.querySelectorAll('[role="tab"]'));
    const panel = experience.querySelector('[role="tabpanel"]');
    const imageBase = 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/';

    function renderScene(target, index) {
      target.querySelector('[data-hv24-title]').textContent = scenes.titles[index];
      target.querySelector('[data-hv24-body]').textContent = scenes.bodies[index];
      target.querySelector('.ah-hv24-quote').textContent = scenes.quotes[index];
      target.querySelector('.ah-hv24-device-pair span').textContent = scenes.products[index];
      target.querySelectorAll('.ah-hv24-device-pair img').forEach((image, position) => {
        const file = scenes.thumbs[index][position];
        image.hidden = !file;
        const link = image.closest('a');
        link.hidden = !file;
        if (!file) {
          image.removeAttribute('src');
          link.removeAttribute('href');
          return;
        }
        image.src = imageBase + file;
        image.alt = scenes.productNames[index][position];
        link.href = scenes.productLinks[index][position];
      });

      const products = target.querySelector('.ah-hv39-products');
      const label = document.createElement('p');
      label.className = 'ah-hv39-products-label';
      label.textContent = scenes.sceneProductLabels[index];
      const row = document.createElement('div');
      row.className = 'ah-hv39-products-row';
      scenes.sceneProducts[index].forEach(([name, file, url]) => {
        const link = document.createElement('a');
        link.href = url;
        const image = document.createElement('img');
        image.src = imageBase + file;
        image.alt = name;
        image.width = 52;
        image.height = 52;
        image.decoding = 'async';
        const text = document.createElement('span');
        text.textContent = name;
        link.append(image, text);
        row.append(link);
      });
      products.replaceChildren(label, row);
    }

    function selectScene(index) {
      experience.dataset.mode = String(index);
      tabs.forEach((tab, position) => {
        tab.setAttribute('aria-selected', String(index === position));
        tab.tabIndex = index === position ? 0 : -1;
      });
      panel.setAttribute('aria-labelledby', tabs[index].id);
      renderScene(panel, index);
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectScene(index));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        selectScene(next);
        tabs[next].focus();
      });
    });
    panel.tabIndex = 0;
    selectScene(0);

    // Measure every scene at the current width so switching tabs does not shift the card.
    const slots = ['[data-hv24-title]', '[data-hv24-body]', '.ah-hv39-products'];
    let previousWidth = -1;
    function stabilizeSceneHeight() {
      const width = panel.getBoundingClientRect().width;
      if (width < 1 || Math.abs(previousWidth - width) < 0.5) return;
      previousWidth = width;
      const heights = slots.map(() => 0);
      tabs.forEach((tab, index) => {
        const probe = panel.cloneNode(true);
        probe.removeAttribute('id');
        probe.removeAttribute('role');
        probe.removeAttribute('aria-labelledby');
        probe.inert = true;
        probe.setAttribute('aria-hidden', 'true');
        probe.querySelectorAll('[aria-live]').forEach((node) => node.removeAttribute('aria-live'));
        probe.style.cssText = `position:absolute;left:0;top:0;visibility:hidden;pointer-events:none;width:${width}px;max-width:none`;
        slots.forEach((selector) => { probe.querySelector(selector).style.minHeight = '0'; });
        renderScene(probe, index);
        panel.parentElement.append(probe);
        slots.forEach((selector, position) => {
          heights[position] = Math.max(heights[position], probe.querySelector(selector).getBoundingClientRect().height);
        });
        probe.remove();
      });
      slots.forEach((selector, position) => {
        panel.querySelector(selector).style.minHeight = `${Math.ceil(heights[position])}px`;
      });
    }
    stabilizeSceneHeight();
    if ('ResizeObserver' in window) {
      new ResizeObserver(stabilizeSceneHeight).observe(panel);
    } else {
      window.addEventListener('resize', stabilizeSceneHeight, { passive: true });
    }
    if (document.fonts) {
      document.fonts.ready.then(() => {
        previousWidth = -1;
        stabilizeSceneHeight();
      });
    }
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const headers = Array.from(document.querySelectorAll('.shopify-section-group-header-group'));
  const mainHeader = document.querySelector('.section-header');
  if (mainHeader && !headers.includes(mainHeader)) headers.push(mainHeader);

  function headerOffset() {
    let bottom = 0;
    headers.forEach((header) => {
      const style = window.getComputedStyle(header);
      const sticky = header.querySelector('sticky-header');
      if (style.position !== 'fixed' && style.position !== 'sticky' && !sticky) return;
      if (style.position === 'sticky' && style.top === 'auto' && !sticky) return;
      // Reserve the height even while Dawn's on-scroll-up header is hidden.
      bottom = Math.max(bottom, header.getBoundingClientRect().height + Math.max(0, parseFloat(style.top) || 0));
    });
    const offset = Math.ceil(bottom) + 20;
    page.style.setProperty('--ah-anchor-offset', `${offset}px`);
    return offset;
  }

  function targetFor(hash) {
    if (!hash || hash === '#') return null;
    try {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      return target && page.contains(target) ? target : null;
    } catch {
      return null;
    }
  }

  function reveal(target) {
    let ancestor = target.parentElement;
    while (ancestor && ancestor !== page) {
      if (ancestor.tagName === 'DETAILS') ancestor.open = true;
      ancestor = ancestor.parentElement;
    }
  }

  function navigate(hash, { smooth = false, focus = true } = {}) {
    const target = targetFor(hash);
    if (!target) return;
    reveal(target);
    window.requestAnimationFrame(() => {
      const top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
      if (focus) {
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
      }
      window.scrollTo({ top: Math.max(0, top), behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant' });
    });
  }

  page.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href^="#"]');
    if (!link || !page.contains(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const hash = link.getAttribute('href');
    if (!targetFor(hash)) return;
    event.preventDefault();
    if (window.location.hash !== hash) window.history.pushState(window.history.state, '', hash);
    navigate(hash, { smooth: true });
  });

  window.addEventListener('hashchange', () => navigate(window.location.hash));
  window.addEventListener('resize', headerOffset, { passive: true });
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(headerOffset);
    headers.forEach((header) => observer.observe(header));
  }
  headerOffset();

  // Direct links can point at products inside initially closed room catalogs.
  const initialHash = window.location.hash;
  if (targetFor(initialHash)) {
    navigate(initialHash, { focus: false });
    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => {
        if (window.location.hash === initialHash) navigate(initialHash, { focus: false });
      }, { once: true });
    }
  }
})();
